// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1046":"866f54bf","2772":"866f54bf","5538":"866f54bf","5928":"866f54bf","7282":"866f54bf"}[chunkId] + ".chunk.css";
};